import * as React from 'react'
import { ReactElement } from 'react'
import { Field, makeStyles, shorthands, tokens } from '@fluentui/react-components'
import LocalDatePicker from '../../../../../components/DatePicker/LocalDatePicker'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'

const useStyles = makeStyles({
    containerColumn: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        ...shorthands.gap(tokens.spacingHorizontalM),
    },
    containerRow: { ...shorthands.gap(tokens.spacingHorizontalM) },
})

export default function Decree({ useColumns, styles, request, setRequest }): ReactElement {
    const themeClassName = useThemeClassName_unstable()
    const decreeStyles = useStyles()
    return (
        <div className={useColumns ? decreeStyles.containerColumn : styles.container}>
            <Field label="Datum beschikking">
                <LocalDatePicker
                    popupSurface={{ className: themeClassName }}
                    isoValue={request.decreeDate}
                    onSelectDate={date => setRequest({ ...request, decreeDate: date })}
                />
            </Field>
            <Field label="Datum inschrijving beschikking">
                <LocalDatePicker
                    popupSurface={{ className: themeClassName }}
                    isoValue={request.decreeRegisterDate}
                    onSelectDate={date => setRequest({ ...request, decreeRegisterDate: date })}
                />
            </Field>
        </div>
    )
}
